/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CreateReportRequest {
    getFixupPrototypeFunction() { return CreateReportRequest.fixupPrototype; }

    static newInstance(model: Partial<CreateReportRequest>): CreateReportRequest {
        let obj = Object.assign(new CreateReportRequest(), model);
        CreateReportRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CreateReportRequest>): CreateReportRequest {
        if (!model) return null;
        return CreateReportRequest.newInstance(<CreateReportRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CreateReportRequest) {
        if (!obj) return;

        models.CreateReportRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CreateReportRequest): boolean {
        Object.setPrototypeOf(obj, CreateReportRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.report_configuration) {
            models.ReportConfiguration.fixupPrototype(this.report_configuration);
        }
        if (this.report_options) {
            models.ReportGenerationOptions.fixupPrototype(this.report_options);
        }
    }

    /**
     * HTML content of report
     */
    html: string;

    /**
     * Relative URL used to generate the report.
     */
    report_generation_url: string;

    /**
     * Dynamic report configuration. Cannot be used with 'html' field.
     */
    report_configuration: models.ReportConfiguration;

    /**
     * User ID of user who requested the report
     */
    user_id: string;

    report_options: models.ReportGenerationOptions;

}
